import {
  BEST_HEADER,
  BEST_TITLE,
  DNF_HEADER,
  DNF_TITLE,
  MEDIAN_HEADER,
  MEDIAN_TITLE,
} from "stats/TimeStats";
import {
  PICKS_HEADER,
  PICKS_TITLE,
  BANS_HEADER,
  BANS_TITLE,
  AVERAGE_PICK_POSITION_HEADER,
  AVERAGE_PICK_POSITION_TITLE,
  PICKED_WHEN_AVAILABLE_HEADER,
  PICKED_WHEN_AVAILABLE_TITLE,
} from "stats/TrackPickStats";
import { SharedTracksStats } from "stats/Tracks/SharedTracksStats";
import { StatTableColumn } from "../../StatTableColumn";

export const SharedTracksStatTableColumns: StatTableColumn<SharedTracksStats>[] =
  [
    {
      type: "Image",
      sortable: true,
      imageUrlGetter: (arg) => arg.thumbnailPath,
      imageTextGetter: (arg) => arg.name,
    },
    {
      type: "Time",
      header: BEST_HEADER,
      title: BEST_TITLE,
      sortable: true,
      timeGetter: (arg) => arg.bestTime.time,
      driverIdsGetter: (arg) => arg.bestTime.driverIds,
    },
    {
      type: "Time",
      header: MEDIAN_HEADER,
      title: MEDIAN_TITLE,
      sortable: true,
      timeGetter: (arg) => arg.medianTime,
    },
    {
      type: "Percent",
      header: DNF_HEADER,
      title: DNF_TITLE,
      sortable: true,
      rateGetter: (arg) => arg.dnfRate.rate,
      subTextGetter: (arg) => arg.dnfRate.breakdown,
      fractionDigits: 1,
      sortDescFirst: true,
    },
    {
      type: "Percent",
      header: PICKS_HEADER,
      title: PICKS_TITLE,
      sortable: true,
      rateGetter: (arg) => arg.pickRate?.rate,
      subTextGetter: (arg) => arg.pickRate?.breakdown,
      fractionDigits: 0,
      sortDescFirst: true,
    },
    {
      type: "Percent",
      header: BANS_HEADER,
      title: BANS_TITLE,
      sortable: true,
      rateGetter: (arg) => arg.banRate?.rate,
      subTextGetter: (arg) => arg.banRate?.breakdown,
      fractionDigits: 0,
      sortDescFirst: true,
    },
    {
      type: "Number",
      header: AVERAGE_PICK_POSITION_HEADER,
      title: AVERAGE_PICK_POSITION_TITLE,
      sortable: true,
      valueGetter: (arg) => arg.averagePickPosition,
      fractionDigits: 2,
    },
    {
      type: "Percent",
      header: PICKED_WHEN_AVAILABLE_HEADER,
      title: PICKED_WHEN_AVAILABLE_TITLE,
      sortable: true,
      rateGetter: (arg) => arg.pickedWhenAvailable?.rate,
      subTextGetter: (arg) => arg.pickedWhenAvailable?.breakdown,
      fractionDigits: 0,
      sortDescFirst: true,
    },
  ];
